import * as React from "react";
import { Chart } from "react-google-charts";

class LineChart extends React.Component {
	render() {
		return (
			<div className={"my-pretty-chart-container"}>
				<Chart
					width={"100%"}
					height={"400px"}
					chartType="LineChart"
					loader={<div>Loading Chart</div>}
					data={this.props.data}
					options={{
						chart: {
							title: "Weekly plotting on the",
							// subtitle: '2017 - 2019',
						},
						hAxis: {
							title: "Week days",
						},
						colors: ["#4FA4D1", "#ED3551", "#745EF2", "#AB8CE4", "#228B22"],
						// vAxis: {
						//   title: 'No. of sample received',
						// },
					}}
					rootProps={{ "data-testid": "2" }}
				/>
			</div>
		);
	}
}
export { LineChart as default };
